// Hideo - dialog widths on large screens: the panel width a dialog asks for (AppDialog.vue, CardDialog.vue) grows from
// 1024 px and again from 1280 and 1536 px, so forms and lists use the room of a computer screen (user request: as wide
// as the screen allows). The small boxes
// (max-w-sm: choices, the app's alert/confirm) keep their width. Classes written whole for Tailwind.
const WIDER: Readonly<Record<string, string>> = {
  'max-w-md': 'max-w-md lg:max-w-lg xl:max-w-xl 2xl:max-w-2xl',
  'max-w-lg': 'max-w-lg lg:max-w-xl xl:max-w-2xl 2xl:max-w-3xl',
  'max-w-xl': 'max-w-xl lg:max-w-3xl xl:max-w-4xl 2xl:max-w-5xl',
  'max-w-2xl': 'max-w-2xl lg:max-w-3xl xl:max-w-5xl 2xl:max-w-6xl'
}

/** The width classes of a dialog panel: its own, plus the wider ones for large screens */
export const dialogWidth = (w: string): string => WIDER[w] || w
